import { render, staticRenderFns } from "./VEditable.vue?vue&type=template&id=19b694cd&lang=pug"
import script from "./VEditable.vue?vue&type=script&lang=js"
export * from "./VEditable.vue?vue&type=script&lang=js"
import style0 from "./VEditable.vue?vue&type=style&index=0&id=19b694cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports